// extracted by mini-css-extract-plugin
export default {"loginButton":"LogoutButton_loginButton__VxxFp"};